import React from 'react';

import { Grid, Box } from '@mui/material';

import { MaintenanceCard } from '../MaintenanceCard';

import type { UnderMaintenanceViewProperties } from './UnderMaintenanceView.types';

export const UnderMaintenanceView: React.FC<UnderMaintenanceViewProperties> = ({
  dataTest = 'under_maintenance_view',
}) => (
  <Box
    data-testid={dataTest}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
    }}
  >
    <Grid
      container
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}>
      <MaintenanceCard />
    </Grid>
  </Box>
);
